import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_created_date', ['createdDate'], {})
@Index('_requestCategory_created_date', ['createdDate', 'requestCategory'], {})
@Entity('_request')
export class RequestEntity extends BaseEntity {
	@Column('int', {
		name: '_creator_userId_delegate',
		nullable: true,
		unsigned: true,
	})
	public creatorUserIdDelegate!: number | null;

	@Column('varchar', { name: '_requestMethod', length: 8 })
	public requestMethod!: string;

	@Column('varchar', { name: '_requestPath', length: 255 })
	public requestPath!: string;

	@Column('text', { name: '_requestQueryString', nullable: true })
	public requestQueryString!: string | null;

	@Column('text', { name: '_requestBody', nullable: true })
	public requestBody!: string | null;

	@Column('text', { name: '_requestHeaders', nullable: true })
	public requestHeaders!: string | null;

	@Column('varchar', { name: '_requestCategory', nullable: true, length: 255 })
	public requestCategory!: string | null;

	@Column('int', { name: '_runtime', nullable: true, unsigned: true })
	public runtime!: number | null;

	@Column('text', { name: '_responseHeaders', nullable: true })
	public responseHeaders!: string | null;

	@Column('text', { name: '_responseBody', nullable: true })
	public responseBody!: string | null;
}
